module.exports = __webpack_public_path__ + "img/ttsMarket3.4f7d2a9a.png";